import React, { useEffect, useState } from "react";

import { apiCall } from "../../../API/apiCall";
import { PUBLIC_URL,BASEURL } from "../../../constant/constant";

import {
  AppStore,
  GooglePlay,
} from "../../../Components/constants/DownloadAppButtons";

import Footer from "../../Footer";
import Navbar from "../../Navbar";
import Loader from "../../loader/Loader";

import "./connectwithus.css";

const MemberTyp = localStorage.getItem("MemberType");

const ConnectWithUs = () => {
  const [isLoader, setisLoader] = useState(false);
  const [links, setLinks] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setisLoader(true);
        const response = await apiCall({
          url: "/social-media/",
          method: "GET",
          params: { isPublish: true },
        });
        console.log(response,"response");
        setLinks(response?.data);
        setisLoader(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setisLoader(false);
      }
    };
    fetchData();
  }, []);

console.log("PUBLIC_URL",PUBLIC_URL);

  return (
    <>
      <Navbar MemberType={MemberTyp} />
      {isLoader && <Loader />}
      <div className="connect-container cstm-social-box">
        <div className="blurred-background">
          <div className="connet-with-wrapper">
            <h4 className="connect-heading">Connect with us on</h4>

            <div className="social-media-main-box">
              {links?.slice(0, 4).map((el, key) => (
                <div key={key} className="social-media-icon-box">
                  <a
                    href={el.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                  >
                    <div className="social-card">
                      <div className="social-icon-box">
                        <img
                          className="icon-image-logo"
                          // src={PUBLIC_URL + "../" + el.icon}
                          src={`${BASEURL}/${el.icon}`}
                        />
                      </div>

                      <p variant="h3" className="social-text">
                        {el.name}
                      </p>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
          <div className="bottom-conatiner">
            <p variant="h2" className="connect-title-1">
              Download our App
            </p>
            <div className="footer-app-icon">
              <a
                href="https://apps.apple.com/us/app/readmax/id6502988625"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <AppStore />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.readmax&hl=en_IN"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <GooglePlay />
              </a>
            </div>
          </div>
        </div>
      </div>
      {!isLoader && <Footer />}
    </>
  );
};

export default ConnectWithUs;
